<template>
  <header class="top-header">
    <div class="logo-section">
      <img
        src="@/assets/images/logo.png"
        class="logo"
        alt="Tire Bank Logo"
      />
      <!-- <span class="title">타이어 바꿀때</span> -->
    </div>
    <!-- <button class="toggle-button" @click="toggleMenu">
      {{ isMenuOpen ? "메뉴 닫기" : "메뉴 열기" }}
    </button> -->
    <nav class="nav-section" v-if="isMenuOpen">
      <div class="nav-row">
        <a href="#" @click.prevent="confirmLogout" class="nav-link">재로그인</a>
        <router-link to="/DrListPage" class="nav-link highlight-golden-yellow">당일순위</router-link>
        <router-link to="/TrListPage" class="nav-link highlight-red record">사업왕순위</router-link>
        <router-link to="/SeListPage" class="nav-link highlight-golden-yellow">점포평가</router-link>
        <!-- <router-link to="/HcListPage" class="nav-link highlight-yellow">인적구성</router-link> -->
        <router-link to="/LsListPage" class="nav-link highlight-yellow">인적구성</router-link>
        <router-link to="/EmListPage" class="nav-link">장비관리</router-link>
        <router-link to="/BrListPage" class="nav-link">청약공고</router-link>
        <router-link to="/BcListPage" class="nav-link record">사업왕<br>성공비결</router-link>
        <router-link v-if="userInfo && userInfo.OGN_FG == '00' " to="/PeListPage" class="nav-link record">FC<br>실적평가</router-link>        
        <router-link v-if="userInfo && userInfo.OGN_FG == '00' && ['관리자1'].includes(userInfo.EMP_NM) " to="/ApListPage" class="nav-link highlight-air">AIR<br>PREMIA</router-link>
      </div>
      <!-- 아랫줄 버튼 -->
      <div class="nav-row">
        <router-link v-if="userInfo && userInfo.OGN_FG == '00' " to="/BmListPage" class="nav-link record">공동브랜드<br>관리</router-link>     
        <router-link to="/BsListPage" class="nav-link">사업현황</router-link>
        <router-link to="/CrListPage" class="nav-link record">진료기록부<br>조회</router-link>
        <router-link to="/QcListPage" class="nav-link">수량증감</router-link>
        <router-link to="/PrListPage" class="nav-link">수익순위</router-link><!-- profitRank -->
        <router-link to="/ScListPage" class="nav-link record">안심보상<br>조회</router-link>
        <router-link to="/TsListPage" class="nav-link">상위20</router-link>
        <router-link to="/BeListPage" class="nav-link">사업학습</router-link>
        <router-link v-if="userInfo &&
          (['김정규', '김종배', '이재진', '육상용', '장영환', '남상만', '김춘규'].includes(userInfo.EMP_NM)||
          ['관리자팀','판매전쟁실'].includes(userInfo.EMP_DEPT_NM))" 
          to="/GtListPage" class="nav-link highlight-blue">GOOD<br>TIRE</router-link>
          <!-- <router-link v-if="userInfo && userInfo.EMP_DEPT_NM === '관리자팀'" to="/SeListPageResponsive" class="nav-link">점포평2</router-link> -->
      </div>
    </nav>
    <!-- <div class="shop-name-display">
      {{ shopName ? shopName : "매장 선택" }}
      <span v-if="telNo" class="shop-tel-display"> ({{ telNo }})</span>
    </div> -->
    <div class="se-list-info-wrapper">

      <table v-if="isDrListPage && activeDrInfo" class="dr-top-info">
        <tbody>
          <tr>
            <td rowspan="3" style="writing-mode: vertical-rl; padding-left: 0px; padding-right: 0px; ">전체</td>
          <td>당일수량</td>
          <td>{{ Number(activeDrInfo.TODAY_SALE_QTY).toLocaleString() }}</td>
          <td>목표수량</td>
          <td>{{ Number(activeDrInfo.MONTH_GOAL_QTY).toLocaleString() }}</td>
        </tr>
        <tr>
          <td>당월수량</td>
          <td>{{ Number(activeDrInfo.MONTH_SALE_QTY).toLocaleString() }}</td>
          <td>당월예상수량</td>
          <td>{{ Number(activeDrInfo.MONTH_EXPECT).toLocaleString() }}</td>
        </tr>
        <tr>
          <td>달성률</td>
          <td>{{ Number(activeDrInfo.GOAL_RATE).toLocaleString() }}%</td>
          <td>수량차이</td>
          <td>{{ Number(activeDrInfo.MINUS_QTY).toLocaleString() }}</td>
        </tr>
        </tbody>
      </table>
      <div v-if="isSeListPage" class="se-list-title">
        <span>{{ shopName === '본사로그인' ? '' : shopName }}<br>위탁 운영 현황표</span>
      </div>
      <div v-if="isSeListPage">
      <!-- <button v-if="isBmListPage" @click="toggleGrid">경영지도</button> -->
      <button  @click="toggleNewSeGridView" class="se-list-button">
      {{ showNewSeListGrid ? "점포운영현황" : "8년수량\n계약수량" }}</button>
      </div>
      <table v-if="isSeListPage || isDrListPage || isTrListPage" class="se-list-shop-info" >
        <tbody>
        <tr>
          <td>점 포 명</td>
          <td>{{ shopName }}</td>
        </tr>
        <tr>
          <td>출력일자</td>
          <td>{{ currentDateTime }}</td>
        </tr>
        <!-- <tr>
          <td>전화번호</td>
          <td>{{ telNo }}</td>
        </tr> -->
        </tbody>
      </table>
      <div v-if="isSeListPage" class="se-list-message">
        <!-- 대한민국에서 20대에 <span style="color: red;">1억이상&nbsp;&nbsp;</span><br> 벌수 있는 곳은 타이어뱅크가&nbsp;&nbsp;<br>유일합니다. -->
        판매약정금 :<br><span style="color: red;">{{ formattedIndexGoal }}</span>
      </div>
      <div v-if="isTsListPage" class="ts-list-message">
        <span style="color: red;">{{previousMonth}}월 상위 20위 사업소득 공개와 사업주모집</span>
      </div>
    </div>
    <div class="bm-list-info-wrapper">
      <!-- <button v-if="isBmListPage" @click="toggleGrid">경영지도</button> -->
       <router-link v-if="isBmListPage && userInfo && ['감사팀','관리자팀','판매전쟁실'].includes(userInfo.EMP_DEPT_NM)" to="/AmListPage" class="nav-link">감사관리</router-link>
      <button v-if="isBmListPage" @click="toggleNewGridView" class="bm-toggle-button">
      {{ showNewGrid ? "달성률 보기" : "경영지도" }}</button>
    </div>
    
    <!-- 장비관리 에서 매장물품관리 URL 이동 -->
    <div v-if="isEmListPage && this.userInfo?.OGN_FG !== '00'" class="em-list-link">
      <button @click="goToEmPage">매장물품관리</button>
    </div>

    <!-- <button class="close-button">X</button> -->
  </header>
</template>

<script>
// import { useRouter } from 'vue-router'

// const router = useRouter()

export default {
  name: "AppHeader",
  props: {
    shopName: {
      // 지점 받을 prop 추가
      type: String,
      default: "",
    },
    telNo: {
      // 전화번호 받을 prop 추가
      type: String,
      default: "",
    },
    activeDrInfo: {
      type: Object,
      default: () => null,
    },
    indexGoal: {
      type: [String, Number],
      default: "",
    },
    // showNewGrid: Boolean, // 신규 그리드 표시 여부
    // 신규 그리드 표시 여부
    showNewSeListGrid: {
      type: Boolean,
      default: false
    },
  },
  data() {
    const now = new Date();
    now.setMonth(now.getMonth() - 1);
    const previousMonth = (now.getMonth() + 1).toString().padStart(2, "0");
    return {
      userInfo: null,
      isMenuOpen: true, // 메뉴 열려 있는지 여부를 관리 (X)
      currentDateTime: "",
      isGridVisible: true, // 그리드 표시 여부
      showNewGrid: false, // 신규 그리드 표시 여부
      // showNewSeListGrid: false, // 점포평가 신규 그리드 표시 여부
      previousMonth,
    };
  },
  watch: {
    // 'activeDrInfo' prop이 변경될 때마다 이 함수가 실행됩니다.
    // activeDrInfo(newVal, oldVal) {
    //   console.log("새로운 값 (newVal):", newVal);
    //   console.log("이전 값 (oldVal):", oldVal); // 필요시 이전 값도 확인 가능
    // }
  },
  mounted() {
    // 컴포넌트가 마운트될 때 현재 시간을 설정
    this.updateDateTime();
    // 필요하다면 1분마다 시간을 업데이트 방법 (선택 사항)
    // this.timer = setInterval(this.updateDateTime, 60000); // 60000ms = 1분
    // 분이 바뀔 때마다 시간을 업데이트하기 위해 타이머 설정
    const now = new Date();
    const delay = (60 - now.getSeconds()) * 1000;
    this.initialTimeout = setTimeout(() => {
      this.updateDateTime();
      this.timer = setInterval(this.updateDateTime, 60000);
    }, delay);

    // localStorage에서 사용자 정보 불러오기
    const userInfoString = localStorage.getItem("userInfo");
    if (userInfoString) {
      this.userInfo = JSON.parse(userInfoString);
      // shopName prop이 전달되지 않았고, OGN_FG가 '00'일 경우 기본값 설정
      if (this.userInfo?.OGN_FG == "00") {
        this.$emit('update:shopName', "본사로그인");
      }
    }
  },
  // beforeDestroy() {
  //   // 컴포넌트가 파괴 전에 타이머 정리(setInterval 사용 시 필요)
  //   // clearInterval(this.timer);
  // },
  beforeUnmount() {
    if (this.initialTimeout) clearTimeout(this.initialTimeout);
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    confirmLogout() {
      if (confirm("재로그인 하시겠습니까?")) {
        this.$router.push("/");
      }
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen; // 메뉴 상태를 토글
    },
    updateDateTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0"); // 월은 0부터 시작 +1
      const day = now.getDate().toString().padStart(2, "0");
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      // const seconds = now.getSeconds().toString().padStart(2, "0"); // 초는 필요 없어 제외

      // 원하는 형식으로 문자열 생성
      this.currentDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;
      // 초까지 포함하려면: `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    toggleNewGridView() {
      this.showNewGrid = !this.showNewGrid;
      // this.showNewSeListGrid = !this.showNewSeListGrid
      this.$emit('toggle-new-grid-view');
    },
    toggleNewSeGridView() {
      // this.showNewGrid = !this.showNewGrid;
      // this.showNewSeListGrid = !this.showNewSeListGrid
      this.$emit('toggle-new-grid-se-view');
    },
    goToEmPage() {
      const shopCd = this.userInfo?.SHOP_CD;
      if (shopCd) {
        const url = `https://manager.tirebank.com/fxtrs/write/0/${shopCd}`;
        window.open(url, "_blank");
      } else {
        alert("매장 정보(SHOP_CD)가 없습니다.");
      }
    },

  },
  computed: {
    formattedIndexGoal() {
      if (this.indexGoal === null || this.indexGoal === undefined) return "0";
      return Number(this.indexGoal).toLocaleString() ;
    },

    isSeListPage() {
      return this.$route.path === "/SeListPage";
    },
    isBmListPage() {
      return this.$route.path === "/BmListPage";
    },
    isDrListPage() {
      return this.$route.path === "/DrListPage";
    },
    isTrListPage() {
      return this.$route.path === "/TrListPage";
    },
    isEmListPage() {
      return this.$route.path === "/EmListPage";
    },
    isTsListPage() {
      return this.$route.path === "/TsListPage";
    },
  },
};
</script>

<style scoped>
/* 전체 헤더 스타일 */
.top-header {
  display: flex;
  align-items: center;
  /* justify-content: flex-start; */
  background-color: blanchedalmond;
  border-bottom: 1px solid black;
  padding: 0.1rem 0.1rem;
  font-family: Arial, sans-serif;
}

/* 로고 섹션 */
/* .logo-section {
} */

.logo {
  width: 120px;
  height: auto;
  display: none;
}

/* .title {
  font-size: 20px;
  font-weight: bold;
  color: red;
} */

/* 네비게이션 섹션 */
.nav-section {
  display: flex;
  flex-direction: column; /* 위아래로 나누기 */
  gap: 1px; /* 줄 간 간격 */
}

.nav-row {
  display: flex;
  flex-wrap: wrap; /* 줄바꿈 허용 */
  gap: 1px; /* 버튼 간 간격 */
  justify-content: flex-start; /* 왼쪽 정렬 */
}

.nav-link {
  padding: 3px 6px; /* 버튼 내부 여백 */
  text-decoration: none;
  color: black;
  font-size: 0.7rem;
  border: 1px solid black;
  border-radius: 3px;
  background-color: white;
  text-align: center;
  box-sizing: border-box; /* 테두리를 포함한 크기 계산 */
  /* 버튼 높이와 줄 간격 고정 */
  min-width: 50px; /* 버튼의 최소 너비 지정 */
  height: 32px; /* 다른 버튼들의 평균적인 높이에 맞춤 */
  line-height: 1.2; /* 줄 간격을 조절하여 텍스트가 넘치지 않게 함 */
  display: inline-flex; /* Flexbox를 사용하여 수직 중앙 정렬 */
  align-items: center; /* Flexbox 아이템을 수직 중앙으로 정렬 */
  justify-content: center; /* Flexbox 아이템을 수평 중앙으로 정렬 */
}

.nav-link.record{
  font-size: 0.7rem;
}


.se-list-info-wrapper {
  margin-left: auto; /* 이 전체 블록을 오른쪽으로 밀어냅니다. */
  display: flex;
  flex-direction: row; /* 자식 요소(메시지, 테이블)를 수직으로 쌓습니다. */
  justify-content: center; /* 자식 요소를 이 래퍼의 오른쪽 가장자리에 정렬합니다. */
  align-items: center; /* 자식 요소를 수직으로 중앙 정렬합니다. */  
}

.se-list-title{
  display: flex;              /* 가운데 정렬을 위해 flex 사용 */
  align-items: center;        /* 세로 가운데 */
  justify-content: center;    /* 가로 가운데 */
  text-align: center; /* 메시지 div 내의 텍스트가 오른쪽 정렬되도록 합니다. */
  font-size: 1rem; /* 선택 사항: 필요시 폰트 크기 조정 */
  background-color: red; /* 선택 사항: 텍스트 색상 조정 */
  font-weight: bold;
  border: 1px solid black; /* 선택 사항: 테두리 추가 */
  width: 10rem;
  padding: 10px;
  height: 40px;
  color: white;
}
.se-list-message {
  text-align: center; /* 메시지 div 내의 텍스트가 오른쪽 정렬되도록 합니다. */
  font-size: 1rem; /* 선택 사항: 필요시 폰트 크기 조정 */
  background-color: yellow; /* 선택 사항: 텍스트 색상 조정 */
  font-weight: bold;
  border: 1px solid black; /* 선택 사항: 테두리 추가 */
  width: 7rem;
  padding: 10px;
  height: 40px;
  /* margin-right: 20px; */
}

.ts-list-message {
  position: fixed;   /* 화면에 고정 */
  right: 10px;       /* 오른쪽 여백 */
  text-align: center; 
  font-size: 1rem; 
  background-color: yellow; 
  font-weight: bold;
  border: 1px solid black; 
  width: 18.5rem;
  padding: 8px;
  height: 25px;
}

.se-list-shop-info {
  margin-left: 2px; /* 메시지와 테이블 사이의 간격 */
  margin-right: 2px; /* 메시지와 테이블 사이의 간격 */
  border-collapse: collapse;
  /* width: 10rem; 테이블 너비 조정 */
  background-color: #a4d1ff;
}

.se-list-shop-info th,
.se-list-shop-info td {
  border: 1px solid black; /* 테두리 추가 */
  border-collapse: collapse;
  text-align: center;
  font-size: 1rem; /* 폰트 크기 조정 */
  height: 28px;
  font-weight: bold;
  padding-left: 10px;
  padding-right: 10px;
}
.dr-top-info {
  margin-left: 2px; /* 메시지와 테이블 사이의 간격 */
  margin-right: 2px; /* 메시지와 테이블 사이의 간격 */
  border-collapse: collapse;
  /* width: 10rem; 테이블 너비 조정 */
  background-color: #d1a3d0;
  margin-top: 1px;
}
.dr-top-info th,
.dr-top-info td {
  border: 1px solid black; /* 테두리 추가 */
  border-collapse: collapse;
  text-align: center;
  font-size: 0.8rem; /* 폰트 크기 조정 */
  height: 20px;
  padding: 0px;
  padding-left: 3px;
  padding-right: 3px;
}

.nav-link:hover {
  background-color: lightgray;
}

/* 강조된 링크 스타일 */
.highlight-yellow {
  background-color: yellow;
  font-weight: bold;
}

.highlight-golden-yellow{
  background-color: #ffc54f;
  font-weight: bold;
}

.highlight-red {
  background-color: red;
  color: white;
  font-weight: bold;
}

.highlight-blue {
  background-color: blue;
  color: white !important;
}

.highlight-air {
  background-color: #2563EB;
  color: #FFB088 !important;
}
/* 토글 버튼 스타일 */
.toggle-button {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 14px;
  cursor: pointer;
}

.toggle-button:hover {
  background-color: #0056b3;
}

.shop-name-display {
  font-size: 1.2rem;
  font-weight: bold;
  margin-left: 1rem;
  color: #d2691e;
}

.shop-tel-display {
  font-size: 0.9rem; /* 매장명보다 약간 작게 */
  color: #555; /* 약간 다른 색상 */
}

.bm-list-info-wrapper {
  margin-left: auto; /* 이 전체 블록을 오른쪽으로 밀어냅니다. */
  display: flex;
  flex-direction: row; /* 자식 요소(메시지, 테이블)를 수직으로 쌓습니다. */
  justify-content: flex-end; /* 자식 요소를 이 래퍼의 오른쪽 가장자리에 정렬합니다. */
  align-items: center; /* 자식 요소를 수직으로 중앙 정렬합니다. */  
}
.bm-toggle-button {
  flex: 1; 
  padding: 5px 10px; /* 버튼 내부 여백 */
  margin-right: 5px;
  margin-left: 5px;
  text-decoration: none;
  color: black;
  font-size: 14px;
  border: 1px solid black;
  border-radius: 3px;
  background-color: white;
  text-align: center;
  box-sizing: border-box; /* 테두리를 포함한 크기 계산 */
  cursor: pointer; /* 커서 모양을 포인터로 변경 */
}

.se-list-button {
  flex: 1; 
  padding: 5px 10px; /* 버튼 내부 여백 */
  margin-right: 5px;
  margin-left: 5px;
  text-decoration: none;
  color: black;
  font-size: 14px;
  border: 1px solid black;
  border-radius: 3px;
  background-color: white;
  text-align: center;
  box-sizing: border-box; /* 테두리를 포함한 크기 계산 */
  cursor: pointer; /* 커서 모양을 포인터로 변경 */
  width: 6.3rem;
  white-space: pre-line;
}

.em-list-link{
  margin-right: 200px;
  text-decoration: none;
  color: black;
  font-size: 14px;
  border: 1px solid black;
  border-radius: 3px;
  background-color: white;
  text-align: center;
  box-sizing: border-box; /* 테두리를 포함한 크기 계산 */
  cursor: pointer;
}

@media (min-width: 1025px) {
  .se-list-title{
    font-size: 1.4rem;
  }
  .nav-link{
    font-size: 0.87rem;
  }
  .logo {
    display: block; /* 1025px 이상일 때만 표시 */
  }
  .nav-link {
    padding: 5px 8px; /* 버튼 내부 여백 */
    text-decoration: none;
    color: black;
    font-size: 0.87rem;
    min-width: 70px
  }
  .highlight-red {
    color: white ;
  }
}
</style>
